module.exports = __webpack_public_path__ + "static/media/customers-benefit-icon.8011b66a.svg";